// src/pages/ParentMessages.jsx
import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";

export default function ParentMessages() {
  const [messages, setMessages] = useState([
    { from: "Teacher", text: "Homework assigned for Monday", time: "10:45 AM" },
    { from: "You", text: "Thank you!", time: "10:47 AM" },
  ]);

  const [text, setText] = useState("");

  const sendMessage = () => {
    if (!text.trim()) return;
    setMessages([...messages, { from: "You", text, time: "Now" }]);
    setText("");
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 3 }}>
        Messages
      </Typography>

      <Paper
        sx={{
          borderRadius: "18px",
          p: 0,
          height: 500,
          display: "flex",
          overflow: "hidden",
        }}
      >
        {/* CHAT LIST */}
        <Box sx={{ width: 260, bgcolor: "rgba(0,0,0,0.03)", p: 2 }}>
          <Typography fontWeight={600} sx={{ mb: 1 }}>
            Chats
          </Typography>
          <List>
            <ListItem selected button>
              <ListItemText primary="Ms. Priya Sharma" secondary="Teacher" />
            </ListItem>
          </List>
        </Box>

        <Divider orientation="vertical" />

        {/* MESSAGE PANEL */}
        <Box sx={{ flex: 1, p: 3, display: "flex", flexDirection: "column" }}>
          <Typography sx={{ fontWeight: 600, mb: 2 }}>
            Ms. Priya Sharma
          </Typography>

          {/* CHAT BODY */}
          <Box sx={{ flex: 1, overflowY: "auto", mb: 2 }}>
            {messages.map((m, i) => (
              <Box
                key={i}
                sx={{
                  mb: 1,
                  textAlign: m.from === "You" ? "right" : "left",
                }}
              >
                <Paper
                  sx={{
                    display: "inline-block",
                    p: 1.2,
                    borderRadius: "12px",
                    bgcolor:
                      m.from === "You"
                        ? "rgba(25,118,210,0.15)"
                        : "rgba(0,0,0,0.05)",
                  }}
                >
                  <Typography>{m.text}</Typography>
                  <Typography sx={{ fontSize: "0.7rem", opacity: 0.7 }}>
                    {m.time}
                  </Typography>
                </Paper>
              </Box>
            ))}
          </Box>

          {/* SEND BOX */}
          <Box sx={{ display: "flex", gap: 1 }}>
            <TextField
              fullWidth
              size="small"
              placeholder="Type your message..."
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
            <Button variant="contained" onClick={sendMessage}>
              Send
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}
